// extracted by mini-css-extract-plugin
export default {"element":"SideList-module--element--adb8a","container":"SideList-module--container--94955","list":"SideList-module--list--d845b"};